import React from 'react';
import classNameBind from 'classnames/bind';
import ActionList from '../../../ActionList';
import styles from './ActionListWrapper.module.css';

const bindClasses = classNameBind.bind(styles);

const ActionListWrapper = props => (
  <div className={bindClasses('wrapper-ctn')}>
    <ActionList {...props} />
  </div>
);

export default ActionListWrapper;
